module.exports = __webpack_public_path__ + "assets/images/mobileMap-bfb526071a8eecaba3ffd51bbadba391.png";